function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

async function initUTMCode() {
  const url = new URL(window.location.href)
  const utmCodeUrl = url.searchParams.get('utm_code')?.toLowerCase()
  const marketingCouponUrl = url.searchParams.get('coupon')?.toLowerCase()

  if (marketingCouponUrl) {
    sessionStorage.setItem('coupon', marketingCouponUrl);
  }

  document.body.addEventListener('docapp-widgets-updated', (e) => { 
    const cart = e.payload;
    if (cart && cart?.hash) {
      let availableCodes = JSON.parse(sessionStorage.getItem('availableCoupons') || '[]');
      const appliedCodes = cart.codes;
      if (appliedCodes.length) {
        appliedCodes.forEach(code => {
          if (!availableCodes.includes(code)) {
            availableCodes.push(code);
          }
        });
      }
      sessionStorage.setItem('availableCoupons', JSON.stringify(availableCodes));

      const discountPicker = document.querySelector('#discount-picker');
      if (discountPicker) {
        const discountPopup = document.querySelector('discount-popup');
        if (discountPopup) {
          discountPopup.populateCodes();
        }
        discountPicker.classList.toggle('hidden', availableCodes.length == 0);
      }

      const savedCoupon = getCookie('coupon');
      const foundCode = appliedCodes.find(code => code?.toLowerCase() == savedCoupon?.toLowerCase());
      if (!foundCode) {
        window.discountOnCartProApp.applyCode(savedCoupon);
      } else {
        setCookie('coupon', savedCoupon, -1);
        setTimeout(() => {
          const alertMessage = document.querySelector('.docapp-coupon-input--message-content');
          if (alertMessage && alertMessage?.textContent?.toLowerCase()?.includes(savedCoupon)) {
            alertMessage.innerHTML = `最高のオファークーポンコード「${foundCode}」がマットレスの元の価格に自動的に適用されます`;
          }
        }, 1000);
      }
    }
  });

  if (!utmCodeUrl) {
    return
  }

  const appliedUtmCode = await pollingCodes()

  await ResourceCoordinator.requestVendor('Toastr')

  if (utmCodeUrl === appliedUtmCode) {
    const { data: cart, ok } = await cartService.get()
    if (ok) {
      if (cart.item_count > 0) {
        toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。`)
      } else {
        toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。 カートに商品を追加すると、割引が適用されます。`)
      }
    } else {
      toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。`)
    }

    return
  }

  window.discountOnCartProApp.applyCode(utmCodeUrl)

  const code = await pollingCodes()
  if (!code || code !== utmCodeUrl) {
    toastr.error('ご入力いただいたクーポンコードが確認できません。')
    return
  }

  const { data: cart, ok } = await cartService.get()
  if (ok) {
    if (cart.item_count > 0) {
      toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。`)
    } else {
      toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。 カートに商品を追加すると、割引が適用されます。`)
    }
  } else {
    toastr.success(`「${utmCodeUrl}」 割引コードが適用されました。`)
  }
}

function pollingCodes() {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const codes = window.discountOnCartProApp?.codes
      if (codes) {
        if (codes.length === 0) resolve('')
        else resolve(codes[0].toLowerCase())
        clearInterval(interval)
      }
    }, 1000)
  })
}


initUTMCode()